export default "__VITE_ASSET__Czo9rLBd__"